import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { environment } from "../../../environments/environment";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "ngx-webstorage";
export var TOKEN_STORAGE = "authenticationToken";
var AuthServerProvider = /** @class */ (function () {
    function AuthServerProvider(http, $localStorage, $sessionStorage) {
        this.http = http;
        this.$localStorage = $localStorage;
        this.$sessionStorage = $sessionStorage;
    }
    AuthServerProvider.prototype.getToken = function () {
        return (this.$localStorage.retrieve(TOKEN_STORAGE) ||
            this.$sessionStorage.retrieve(TOKEN_STORAGE) ||
            "");
    };
    AuthServerProvider.prototype.setToken = function (token) {
        this.$sessionStorage.store(TOKEN_STORAGE, token);
    };
    AuthServerProvider.prototype.login = function (credentials) {
        var _this = this;
        return this.http
            .post(environment.apiURL + "login/authenticate", credentials)
            .pipe(map(function (response) { return _this.authenticateSuccess(response); }));
    };
    AuthServerProvider.prototype.loginClave = function (token) {
        this.authenticateSuccess(token);
    };
    AuthServerProvider.prototype.logout = function () {
        var _this = this;
        return new Observable(function (observer) {
            _this.$localStorage.clear(TOKEN_STORAGE);
            _this.$sessionStorage.clear(TOKEN_STORAGE);
            observer.complete();
        });
    };
    AuthServerProvider.prototype.anonymous = function (appId) {
        var _this = this;
        return this.http
            .post(environment.apiURL + "login/anonymous", appId)
            .pipe(map(function (response) { return _this.authenticateSuccess(response); }));
    };
    AuthServerProvider.prototype.authenticateSuccess = function (response) {
        var jwt = response.id_token;
        this.$sessionStorage.store(TOKEN_STORAGE, jwt);
    };
    AuthServerProvider.ngInjectableDef = i0.defineInjectable({ factory: function AuthServerProvider_Factory() { return new AuthServerProvider(i0.inject(i1.HttpClient), i0.inject(i2.LocalStorageService), i0.inject(i2.SessionStorageService)); }, token: AuthServerProvider, providedIn: "root" });
    return AuthServerProvider;
}());
export { AuthServerProvider };
